import React from 'react';
import revampData from '../../data/revampData.json';
import { theme, websiteColors } from "../../themes/Theme.js";
const FeatureIntroSection = () => {
  const featureIntroSections = revampData.data.listFeatureIntroSections.data;
  return <div className='px-sm-4 px-3 font-figtree' data-sentry-component="FeatureIntroSection" data-sentry-source-file="FeatureIntroSection.jsx">
            <div className="text-center py-5">
                {/* Features Section */}
                {featureIntroSections.map((section, index) => <div key={index} className="d-flex justify-content-center align-items-center gap-4">
                        {/* Title and Subtitle */}
                        <div className="text-center intro-container d-flex flex-column justify-content-center align-items-center gap-2">
                            <span className="text-uppercase text-tertiary text-primary d-block " style={{
            fontWeight: '600',
            letterSpacing: '2px'
          }}>
                                {section.featuresData.section}
                            </span>
                            <h1 className=" section-title">{section.featuresData.title}</h1>
                            <p className="d-lg-block  d-sm-none d-block section-subtitle">
                                {section.featuresData.subtitle}
                            </p>
                            <p className="d-lg-block d-sm-none d-block section-subtitle mt-1">
                                {section.featuresData.description}
                            </p>
                            <p className='d-lg-none d-sm-block d-none section-subtitle'>
                            {section.featuresData.subtitle}   {section.featuresData.description}
                            </p>
                        </div>
                    </div>)}
            </div>
            <style jsx>{`
                .intro-container {
                    max-width: 885px;
                    width: 100%;
                }
                .section-title{
                    font-weight:600;
                    font-size:36px;
                    line-height:44px;
                    color:#101828;
                }
                .section-subtitle{
                font-weight:400;
                    font-size:20px;
                    line-height:30px;
                   // color:${websiteColors[theme].textSecondary};
                   color:#475467;
                }
                @media screen and (max-width: 576px) {
                    .section-title{
                        font-size:32px;
                        max-width:306px;
                    }
                }
            `}</style>
        </div>;
};
export default FeatureIntroSection;